export default "__VITE_ASSET__be9c856a__"